import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    annulerEntretienAnnuelRequest,
    confirmerEntretienAnnuelRequest,
    fetchEntretienAnnuelRequest,
    planifierEntretienAnnuelRequest,
    replanifierEntretienAnnuelRequest,
    terminerEntretienAnnuelRequest,
} from "../../../redux/actions/performanceActions";
import { formatDateTimeInput } from "../Collaborateur/performanceUi";

const initialForm = {
    dateDebut: "",
    dateFin: "",
    lieu: "",
    description: "",
    notes: "",
    sendInvitation: true,
};

function Field({ label, children }) {
    return (
        <label className="perf-field">
            <span>{label}</span>
            {children}
        </label>
    );
}

export default function EntretienAnnuelModal({ open, progressId, title = "Entretien annuel", onClose, showManagerActions = false }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.entretienAnnuel);
    const entretien = progressId ? slice.byProgressId[String(progressId)] : null;
    const loading = progressId ? slice.loadingByProgressId[String(progressId)] : false;
    const error = progressId ? slice.errorByProgressId[String(progressId)] : null;
    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        if (open && progressId) {
            dispatch(fetchEntretienAnnuelRequest(progressId));
        }
    }, [dispatch, open, progressId]);

    useEffect(() => {
        if (!open) return;
        if (entretien) {
            setForm({
                dateDebut: formatDateTimeInput(entretien.dateDebut),
                dateFin: formatDateTimeInput(entretien.dateFin),
                lieu: entretien.lieu || "",
                description: entretien.description || "",
                notes: entretien.notes || "",
                sendInvitation: true,
            });
        } else {
            setForm(initialForm);
        }
    }, [entretien, open]);

    if (!open) return null;

    const update = (patch) => setForm((current) => ({ ...current, ...patch }));
    const payload = () => ({ ...form, evaluationProgressId: Number(progressId) });

    const submit = (event) => {
        event.preventDefault();
        if (!progressId) return;
        if (entretien?.id) dispatch(replanifierEntretienAnnuelRequest(entretien.id, payload()));
        else dispatch(planifierEntretienAnnuelRequest(payload()));
    };

    return (
        <div className="perf-modal-backdrop" role="presentation" onMouseDown={onClose}>
            <section className="perf-modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
                <header className="perf-modal__header">
                    <div>
                        <h2>{title}</h2>
                        <p>{entretien ? `Statut: ${entretien.statut || "-"}` : "Planification de l'invitation calendrier"}</p>
                    </div>
                    <button className="perf-modal__close" type="button" onClick={onClose} aria-label="Fermer">x</button>
                </header>

                {loading && <div className="perf-state">Chargement de l'entretien...</div>}
                {error && <div className="perf-state perf-state--error">{error}</div>}

                <form className="perf-modal__body" onSubmit={submit}>
                    <div className="perf-form-row">
                        <Field label="Debut">
                            <input required type="datetime-local" value={form.dateDebut} onChange={(event) => update({ dateDebut: event.target.value })} />
                        </Field>
                        <Field label="Fin">
                            <input required type="datetime-local" value={form.dateFin} onChange={(event) => update({ dateFin: event.target.value })} />
                        </Field>
                        <Field label="Lieu">
                            <input value={form.lieu} onChange={(event) => update({ lieu: event.target.value })} />
                        </Field>
                    </div>

                    <Field label="Description">
                        <textarea value={form.description} onChange={(event) => update({ description: event.target.value })} />
                    </Field>
                    <Field label="Notes">
                        <textarea value={form.notes} onChange={(event) => update({ notes: event.target.value })} />
                    </Field>

                    <label className="perf-check">
                        <input type="checkbox" checked={form.sendInvitation} onChange={(event) => update({ sendInvitation: event.target.checked })} />
                        Envoyer l'invitation calendrier
                    </label>

                    <footer className="perf-modal__footer">
                        <button className="perf-btn" type="button" onClick={onClose}>Annuler</button>
                        {entretien?.id && (
                            <button className="perf-btn" type="button" onClick={() => dispatch(confirmerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId) }))}>
                                Confirmer
                            </button>
                        )}
                        {showManagerActions && entretien?.id && (
                            <>
                                <button className="perf-btn" type="button" onClick={() => dispatch(annulerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId), notes: form.notes }))}>
                                    Annuler entretien
                                </button>
                                <button className="perf-btn" type="button" onClick={() => dispatch(terminerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId), notes: form.notes }))}>
                                    Terminer
                                </button>
                            </>
                        )}
                        <button className="perf-btn perf-btn--primary" type="submit" disabled={!progressId || loading}>
                            {entretien?.id ? "Replanifier" : "Planifier"}
                        </button>
                    </footer>
                </form>
            </section>
        </div>
    );
}
